import { Fragment, useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Grid, InputAdornment, TextField } from "@mui/material";
import { Pagination } from "../Pagination/index";
import { JsonDataTooltip } from "../JSONTooltip/JsonTooltip";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import {  connect } from "react-redux";
import { withRouter} from "react-router-dom";
import _ from "lodash";
import { getEdgeEventsTable, getEdgeEventsTableCount } from "../../actions/Users/authenticateEdgeEvents";
import { convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI } from "../../utils/util";
import "./style.css";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import NewDownloadButton from '../../asset/image/NewDownloadButton.svg';
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import DownloadCSV, { clearCsvDownload } from "../DownloadCSV";

const ENTER_KEY_CODE = 'Enter';

const convertToCsv = (data: any[][], userTimezone: string) => {
    const [_columns, ...rows] = data;
    const csvRows: any[] = [];
    rows.forEach(row => {
        csvRows.push([convertDateTimeIntoTimezone(row[0], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS), row[8], row[2], row[6], row[3], row[4],  row[5], row[7]])
    })
    let timestamp = 'Timestamp (' + userTimezone + ')'
    return [[timestamp, 'Site Name', 'DID', 'SOURCE', 'Level', 'Module', 'Description', 'Metadata'], ...csvRows]
}

const ChartTable = (props: any) => {
    const { authReducer, parameters, getEdgeEventsTable, getEdgeEventsTableCount, history, location, Page, setPage, downloadAsCSV } = props;
    let _q = getDecodeURI(location?.search);
    const [edgeTable, setEdgeTable] = useState<any>([]);
    const [count, setCount] = useState(0);
    const DEFAULT_PAGE_SIZE = 10;
    const [Limit, setLimit] = useState(_q.hasOwnProperty("limit") ? parseInt(_q.limit) : DEFAULT_PAGE_SIZE);
    const [searchValue, setSearchValue] = useState("");
    const [search, setSearch] = useState("");
    const searchTimeoutRef = useRef<any>();
    const dispatch = useDispatch();

    useEffect(() => {
        if (Object.keys(parameters).length) {
            getEdgeEventsTable({...parameters, offset: ((Page-1)*Limit), pageSize: Limit, search: search !== "" ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${search}%' OR  b_metadata ILIKE '%${search}%')` : "" })
            getEdgeEventsTableCount({...parameters, offset: ((Page-1)*Limit), pageSize: Limit, search: search !== "" ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
                if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${search}%' OR  b_metadata ILIKE '%${search}%')` : ""})
        }
    },[parameters, search])

    useEffect(() => {
      if(!_.isEmpty(authReducer.getEdgeEventsTable)) {
        const data = authReducer?.getEdgeEventsTable?.hasOwnProperty('data') ? authReducer?.getEdgeEventsTable?.data : {};
        if(data) {
            const rows: any[] = data?.rows;
            const columns: string[] = data?.columns;
            const edgeData: any[] = [];
            for (let i = 0; i < rows?.length; i++) {
                const row = {};
                const currentRow = rows[i];
                columns.forEach((column, index) => {
                    row[column] = currentRow[index];
                })
                edgeData.push(row);
            }
            setEdgeTable(edgeData);
          }
      } else {
        setEdgeTable([]);
      }
      if(!_.isEmpty(authReducer.getEdgeEventsTableCount)) {
        const data = authReducer?.getEdgeEventsTableCount.hasOwnProperty('data') ? authReducer?.getEdgeEventsTableCount?.data?.filters?.data[4] : 0;
        setCount(data);
      } else {
        setCount(0)
      }
    },[authReducer.getEdgeEventsTable, authReducer.getEdgeEventsTableCount])

    const handleChangePage = (e, value) => {
        const page = value;
        let params: any = getDecodeURI(location?.search);
        params.page = value;
        setPage(page);
        doNavigate(params);
        getEdgeEventsTable({...parameters, offset: ((page-1)*Limit), pageSize: Limit, search: search !== "" ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${search}%' OR  b_metadata ILIKE '%${search}%')` : ""})
        getEdgeEventsTableCount({...parameters, offset: ((page-1)*Limit), pageSize: Limit, search: search !== "" ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${search}%' OR  b_metadata ILIKE '%${search}%')` : ""})
    }
    
      const handleChangeRowsPerPage = (e) => {
        const limit = parseInt(e.target.value);
        const page = 1;
        let params: any = getDecodeURI(location?.search);
        params.page = 1;
        params.limit = limit;
        setPage(1);
        setLimit(limit);
        doNavigate(params);
        getEdgeEventsTable({...parameters, offset: ((page-1)*limit), pageSize: limit, search: search !== "" ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${search}%' OR  b_metadata ILIKE '%${search}%')` : ""})
        getEdgeEventsTableCount({...parameters, offset: ((page-1)*limit), pageSize: limit, search: search !== "" ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
            if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${search}%' OR  b_metadata ILIKE '%${search}%')` : ""})
    }

    const doNavigate = (params) => {
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    }

    const rowsOption = [10, 15, 25, 50, 100];
    const searchBoxKeyDown = (event: any) => {
            if (event && event.key === ENTER_KEY_CODE) {
                handleSearch(searchValue);
            }
        }
    
        const handleOnSearchClick = () => {
            handleSearch(searchValue);
        }
    
        const handleOnSearchClear = () => {
            setSearchValue('');
            handleSearch('');
        }
    
        const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
            setSearchValue(e.target.value);
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
            searchTimeoutRef.current = setTimeout(() => {
                searchTimeoutRef.current = undefined;
                handleSearch(e.target.value);
            }, 1000)
        }
    
        const handleSearch = (value: string) => {
            setSearch(value);
            let params: any = getDecodeURI(location?.search);
            value ? params.search = value : delete params.search;
            delete params.page;
            doNavigate(params);
        }
    const handleDownlodReport = () => {
        if (count <= 0) return;
        const params: CsvParameters = {
            type: 'QUERY_CH',
            id: 'topology-sdwan-edge-events',
            payload: { ...parameters, offset: 0, pageSize: count,  search: search !== "" ? `and (concat_ws(',',if(device_id IS NULL,'',device_id),if(deviceAlias IS NULL,'',deviceAlias),if(level IS NULL,'',level),if(deviceAlias IS NULL,'',deviceAlias),
                if(description IS NULL,'',description),if(source IS NULL,'',source)) ILIKE '%${search}%' OR  b_metadata ILIKE '%${search}%')` : ""},
            queryName: 'EDGE_EVENTS',
        }
        downloadAsCSV(params);
    }

    useEffect(() => {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
            if (authReducer.csvDownloadId === 'topology-sdwan-edge-events') {
                DownloadCSV(convertToCsv(authReducer.csvDataDownloded, authReducer.userTimezone)
                    , {
                        formatters: {
                            0: 'ESC-COMMA',
                            1: 'ESC-COMMA',
                            2: 'ESC-COMMA',
                            5: 'ESC-COMMA',
                            6: "JSON"
                        }
                    }
                );
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [authReducer.csvDataDownloded])

    return (
        <Grid className="chartsEventTableContainer">
            <Grid className="alignTopbarItemsCenter">
                <Grid item xs={2} sm={2} md={2} lg={2} className="searchbarMaxWidth">
                    <Box className="searchbarBox">
                        <TextField
                            id="search"
                            variant="outlined" 
                            placeholder="Type something"
                            autoComplete="off"
                            size="small"
                            value={searchValue}
                            onChange={handleOnSearchChange}
                            onKeyDown={(event) => searchBoxKeyDown(event)}
                            InputLabelProps={{ className: "serachLabel" }}
                            InputProps={{
                                className: "searchbarInputs",
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {!searchValue && <SearchIcon
                                            className="searchbarIconsPosition" onClick={handleOnSearchClick}
                                        />}
                                        {searchValue && <CloseIcon
                                            className="searchbarIconsPosition"
                                            onClick={handleOnSearchClear}
                                        />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </Grid>
                <div className="displayFlex marginLeftAuto" onClick={handleDownlodReport}>
                    <img id="downloadIcon" src={NewDownloadButton} alt="" />
                </div>
            </Grid>
            <Grid>
            <Paper className="pagination-position usage-pagination">
                    <Pagination
                        rowsPerPageOptions={rowsOption}
                        count={Number(count)}
                        rowsPerPage={Limit}
                        page={Page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
                <TableContainer className="usageReports-FleetDashboard chartEvent-FleetDashboard">
                    <Table aria-label="simple table">
                        <TableHead className="usageReports-tableHead">
                            <TableRow className="UsageReports-tableRow">
                                <TableCell className="usage-fleetDataTable">TIMESTAMP</TableCell>
                                <TableCell className="usage-fleetDataTable">DID</TableCell>
                                <TableCell className="usage-fleetDataTable">SOURCE</TableCell>
                                <TableCell className="usage-fleetDataTable">LEVEL</TableCell>
                                <TableCell className="usage-fleetDataTable">MODULE</TableCell>
                                <TableCell className="usage-fleetDataTable user-fleetDataTable">DESCRIPTION</TableCell>
                                <TableCell className="usage-fleetDataTable">METADATA</TableCell>
                            </TableRow>
                        </TableHead>
                        {0 != edgeTable.length ? (
                            <TableBody className="tableBody usage-tableBody">
                                {
                                    edgeTable && edgeTable.map((row, i) =>
                                        <TableRow className="usageData-tabelRow chartEvent-tableRow">
                                            <TableCell className="usagedata-tableCell chartEvent-tablecell">{convertDateTimeIntoTimezone(row['ts'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</TableCell>
                                            <TableCell className="usagedata-tableCell chartEvent-tablecell">{row['device_id']}</TableCell>
                                            <TableCell className="usagedata-tableCell chartEvent-tablecell chartEvent-tablecell-source">{row['source']}</TableCell>
                                            <TableCell className="usagedata-tableCell chartEvent-tablecell">{row['level']}</TableCell>
                                            <TableCell className="usagedata-tableCell chartEvent-tablecell">{row['module']}</TableCell>
                                            <TableCell className="usagedata-tableCell chartEvent-tablecell">{row['description']}</TableCell>
                                            <TableCell className="usagedata-tableCell chartEvent-tablecell">
                                                <JsonDataTooltip data={row['metadata']} />
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                            ) : <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={6} className="noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>
                        }                                     
                    </Table>
                </TableContainer>
                
            </Grid>
        </Grid>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
});

export default withRouter(
    connect(mapStateToProps, {
        getEdgeEventsTable,
        getEdgeEventsTableCount,
        downloadAsCSV
    })(ChartTable)
);